/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetInternalSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetInternalSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetInternalSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetInternalSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  GetInternalSessionIssuerSecurity$Outbound,
  GetInternalSessionIssuerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getInternalSessionIssuerSecurityToJSON(
  getInternalSessionIssuerSecurity: GetInternalSessionIssuerSecurity,
): string {
  return JSON.stringify(
    GetInternalSessionIssuerSecurity$outboundSchema.parse(
      getInternalSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type GetInternalSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetInternalSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  GetInternalSessionIssuerRequest$Outbound,
  GetInternalSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getInternalSessionIssuerRequestToJSON(
  getInternalSessionIssuerRequest: GetInternalSessionIssuerRequest,
): string {
  return JSON.stringify(
    GetInternalSessionIssuerRequest$outboundSchema.parse(
      getInternalSessionIssuerRequest,
    ),
  );
}
